import React from "react";

export default ({value, id, placeholder, updateForm}) => <input className="form__field" id={id} type={'password'} placeholder={placeholder} value={value ?? ''} onChange={e => updateForm(e.target.value)}/>
